import { Stack, Text } from "@mantine/core";

interface ReservationPreferencesSectionProps {
  preferredLanguage: string | null;
  preferredCost: string | null;
  dietaryRestrictionSlugs: string[];
  dietaryRestrictionsOtherText?: string | null;
  messageForGuests?: string | null;
}

const LANGUAGE_LABELS: Record<string, string> = {
  KOREAN: "한국어",
  ENGLISH: "English",
  BOTH: "한국어 & English",
};

const COST_LABELS: Record<string, string> = {
  LOW: "저렴 (₩15,000-25,000)",
  MEDIUM: "보통 (₩25,000-35,000)",
  HIGH: "비쌈 (₩35,000+)",
};

const DIETARY_LABELS: Record<string, string> = {
  NONE: "없음",
  VEGAN: "비건",
  VEGETARIAN: "채식",
  GLUTEN_FREE: "글루텐 프리",
  OTHER: "기타",
};

export const ReservationPreferencesSection = ({
  preferredLanguage,
  preferredCost,
  dietaryRestrictionSlugs,
  dietaryRestrictionsOtherText,
  messageForGuests,
}: ReservationPreferencesSectionProps) => {
  return (
    <Stack gap="xs">
      <Text size="sm" c="black">
        <strong>선호 언어:</strong>{" "}
        {preferredLanguage ? LANGUAGE_LABELS[preferredLanguage] || preferredLanguage : "N/A"}
      </Text>

      <Text size="sm" c="black">
        <strong>선호 가격대:</strong>{" "}
        {preferredCost ? COST_LABELS[preferredCost] || preferredCost : "N/A"}
      </Text>

      <Text size="sm" c="black">
        <strong>식이 제한:</strong>{" "}
        {dietaryRestrictionSlugs && dietaryRestrictionSlugs.length > 0
          ? dietaryRestrictionSlugs.map((slug) => DIETARY_LABELS[slug] || slug).join(", ")
          : "없음"}
      </Text>

      {dietaryRestrictionsOtherText && (
        <Text size="sm" pl="md" c="dimmed">
          <em>기타 상세: {dietaryRestrictionsOtherText}</em>
        </Text>
      )}

      {messageForGuests && (
        <Text size="sm" c="black">
          <strong>게스트에게 전할 메시지:</strong>
          <br />
          <Text size="sm" pl="md" c="dimmed" style={{ fontStyle: "italic" }}>
            "{messageForGuests}"
          </Text>
        </Text>
      )}
    </Stack>
  );
};
